import { useRef, useEffect, useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

interface AccordionProps {
  title: string;
  content: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}

const Accordion = ({ title, content, isOpen, onToggle }: AccordionProps) => {
  const [height, setHeight] = useState<number | null>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [isOpen]);

  return (
    <div className="border border-gray-200  rounded-lg overflow-hidden transition-all duration-300 ease-in-out">
      <button
        className="w-full hover:cursor-pointer  px-6 py-4 text-left flex justify-between items-center focus:outline-none"
        onClick={onToggle}
        type="button"
      >
        <span className="font-medium  text-gray-800">{title}</span>
        {isOpen ? (
          <FiChevronUp className="text-[#1c9e86] hover:cursor-pointer  transition-transform duration-300" />
        ) : (
          <FiChevronDown className="text-[#1c9e86] hover:cursor-pointer  transition-transform duration-300" />
        )}
      </button>
      <div
        className="bg-[#f7fafc]  transition-all duration-500 ease-in-out"
        style={{
          maxHeight: `${height}px`,
          opacity: isOpen ? 1 : 0,
          transform: isOpen ? 'translateY(0)' : 'translateY(-10px)',
          overflow: 'hidden',
        }}
      >
        <div ref={contentRef} className="px-6  py-4 text-gray-800">
          {content}
        </div>
      </div>
    </div>
  );
};

export default Accordion;